// extracted by mini-css-extract-plugin
export default {"overlay":"articleOverlay_overlay__Zmu7p","overlay_active":"articleOverlay_overlay_active__mMQgw"};